/**
 * Escapes the characters that have a meaning in HTML.
 */
export function escapeHtml(text: string): string {
  return text
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;')
}

/** Tags the search index may wrap around a matched token. */
const HIGHLIGHT_TAGS = ['em', 'mark'] as const

/**
 * Sanitizes a search highlight snippet for v-html.
 *
 * Elasticsearch wraps matched tokens in <em> (the default highlighter tags).
 * Typesense / other indexes may use <mark>. The rest of the snippet is text,
 * never markup: everything except those bare highlight tags is escaped.
 */
export function sanitizeSearchHighlight(snippet: string): string {
  let result = escapeHtml(snippet)
  for (const tag of HIGHLIGHT_TAGS) {
    result = result
      .replaceAll(`&lt;${tag}&gt;`, `<${tag}>`)
      .replaceAll(`&lt;/${tag}&gt;`, `</${tag}>`)
  }
  return result
}
